import React, { useState, useEffect } from "react";
import {
  TabsPaneEA,
  DataExportPrint,
  IconPadding,
  StyleLessButtons,
  ActionTitle,
  ActionItems,
  AlignCenter,
  AlignTableContents
} from "./style";
import { IconsPlaceNew } from "../../../InvestmentOptionDetails/styles";
import TabsComponent from "../../../../../../CommonComponents/TabsComponent/TabsComponent";
import Exchanges from "../Exchanges/Exchanges";
import { withRouter } from "react-router-dom";
import { Row, Col, Tooltip } from "antd";
import { TabsPane } from "../../../../../../CommonComponents/TabsComponent/styles";
import RenderCard from "../RenderCard/RenderCard";
import { TableLabel, ContentDivider } from "../../style";
import { setExchangeType, cancelTxnSchedule, setTab } from "../../actions";
import moment from "moment";
import recurringIcon from "../../../../../../assets/icons/recurring.svg";
import exportIcon from "../../../../../../assets/icons/export.svg";
import printIcon from "../../../../../../assets/icons/print.svg";
import { connect } from "react-redux";
import history from "../../../../../../history/history";
import AdvancedSearch from "./AdvancedSearch";
import { AlertMessagePrimary } from "../AlertPopUp/AlertPopUp";
import PrintComponents from "react-print-components";
import ExchangeSelectPrint from "./ExchangeSelectPrint";
import { analyticsTracking } from "./analytics";
import { getPrimaryAccount } from "../../../../../../utils/sessionUtil";
import Workbook from "react-excel-workbook";
import { checkCSRBusinessFunction } from "../../../../../../CSR/utils/CommonUtils";
import { recordError } from "../../../../../../utils/commonUtil";
import { BUSINESS_FUNCTION } from "../../../../../../CSR/utils/csrBusinessFunctionMapper";
import { MenuContentWrapper } from "../../../../../../CommonComponents/commonStyles";
import tableIcon from "../../../../../../assets/icons/table-action-button.png";
import tableIconGrey from "../../../../../../assets/icons/table-action-button-grey.png";
import infoIcon from "../../../../../../assets/icons/shape.svg";
import { PropTypes } from "prop-types";
import { isReadOnlyWithExchangeRole } from "../../../RecommendAnExchangeNew/util";
import { exportExcelTableData } from "../../../../../../services/apiServices";

const tabConfig = function destObj(data, columnConfig, unUsed, options,  findExpanded, getPageTitle, exportDataUpdate) {
  return [
    {
      render: (
        <Exchanges
          tab="1"
          data={data}
          options={options}
          column={columnConfig}
          exportDataUpdate={exportDataUpdate}
        />
      )
    },
    {
      render: (
        <Exchanges
          tab="2"
          data={data}
          options={options}
          column={columnConfig}
          exportDataUpdate={exportDataUpdate}
        />
      )
    }
  ];
};

export const compareByAlph = (a, b) => {
  if (a > b) {
    return -1;
  }
  if (a < b) {
    return 1;
  }
  return 0;
};
export  const renderValues = (value, row, props, tabIndex, handleSinglePop) => {
  const activateCTA = ["Entered", "Hold"];
  const { access } = props.user.role;
  if (value.status.description === activateCTA[0] && (access === "All Access" || isReadOnlyWithExchangeRole())) {
    return (
      <>
        <MenuContentWrapper>
          <ActionItems
            id={"anrViewAndEdit" + row.txnId}
            data-test="action-item"
            onClick={e => {
              try {
                e.stopPropagation();
                analyticsTracking("viewEdit", tabIndex);
                switch (row.exchangetype) {
                  case "From TIFF":
                    history.push({
                      pathname: `/view-edit-tiff-from/${row.txnId}/edit`
                    });
                    break;
                  case "To TIFF":
                    history.push({
                      pathname: `/view-edit-tiff-into/${row.txnId}/edit`
                    });
                    break;
                  default:
                    history.push({
                      pathname: `/investments/recommend-an-exchange/${row.txnId}`,
                      search: `type=onetime`,
                      state: { txn: row, page: "edit" }
                    });
                    break;
                }
              } catch (error) {
                recordError(error);
              }
            }}
          >
            View & Edit
          </ActionItems>
        </MenuContentWrapper>
        {activateCTA.includes(value.status.description) && (
          <>
            <MenuContentWrapper>
              <ActionItems
                data-test="anr-cancelled"
                onClick={() => handleSinglePop(row.txnId)}
                id={"anrCancelled" + row.txnId}
              >
                {props.cancel >= 0 &&
                row.status.extDescription == "Cancelled" ? (
                  <>Cancelled</>
                ) : (
                  <>Cancel Transaction</>
                )}
              </ActionItems>
            </MenuContentWrapper>
          </>
        )}
      </>
    );
  } else
    return (
      <MenuContentWrapper>
        <ActionItems
          onClick={e => {
            try {
              e.stopPropagation();
              analyticsTracking("viewEdit", tabIndex);
              switch (row.exchangetype) {
                case "From TIFF":
                  history.push({
                    pathname: `/view-edit-tiff-from/${row.txnId}/edit`
                  });
                  break;
                case "To TIFF":
                  history.push({
                    pathname: `/view-edit-tiff-into/${row.txnId}/edit`
                  });
                  break;
                default:
                  history.push({
                    pathname: `/investments/recommend-an-exchange/${row.txnId}`,
                    search: `type=onetime`,
                    state: { txn: row, page: "edit" }
                  });
                  break;
              }
            } catch (error) {
              recordError(error);
            }
          }}
          id={"anrView" + row.txnId}
        >
          View
          <br />
        </ActionItems>
      </MenuContentWrapper>
    );
};
export const renderRecurringValues = (value, row, props, tabIndex, handlePop) => {
  const { access } = props.user.role;
  if (row.status === "Active" && (access === "All Access" || isReadOnlyWithExchangeRole()) ) {
    return (
      <>
        <MenuContentWrapper>
          <ActionItems
          data-test="anrViewAndEdit2"
            id={"anrViewAndEdit2" + row.exchScheduleId}
            onClick={e => {
              try {
                e.stopPropagation();
                analyticsTracking("viewEdit", tabIndex);
                history.push({
                  pathname: `/investments/recommend-an-exchange/${row.exchScheduleId}/view`,
                  search: "type=recurring",
                  state: { txn: row }
                });
              } catch (error) {
                recordError(error);
              }
            }}
          >
            View & Edit
          </ActionItems>
        </MenuContentWrapper>
        <MenuContentWrapper>
          <ActionItems
            id={"anrCancelTransaction2" + row.exchScheduleId}
            onClick={() => handlePop(row.exchScheduleId)}
            disabled={checkCSRBusinessFunction(
              BUSINESS_FUNCTION[
                "DONOR_PORTAL_EDIT_RECURRING_EXCHANGE_FULL_ACCESS"
              ],
              props.csrBusinessFunction
            )}
          >
            Cancel Transaction{" "}
          </ActionItems>
        </MenuContentWrapper>
      </>
    );
  } else
    return (
      <>
        <MenuContentWrapper>
          <ActionItems
            id={"anrView2" + row.exchScheduleId}
            onClick={e => {
              try {
                e.stopPropagation();
                analyticsTracking("view", tabIndex);
                history.push({
                  pathname: `/investments/recommend-an-exchange/${row.exchScheduleId}/view`,
                  search: "type=recurring",
                  state: { txn: row }
                });
              } catch (error) {
                recordError(error);
              }
            }}
          >
            View
          </ActionItems>
        </MenuContentWrapper>
      </>
    );
};

export function ExchangeSelect(props) {
  const TabPane = TabsPane.TabPane;
  const [popup, setPopup] = useState(false);
  const [active, setActive] = useState("1");
  const [scheduleId, setSelectedschedule] = useState("");
  const [singleExchangePop, setSinglePopup] = useState(false);
  const [txnId, setSelectedTxn] = useState("");
  const [setFilter] = useState(false);
  const [filterUsed, setFilterUsed] = useState(false);
  const [otData, setOtData] = useState(null);
  const [fData, setFData] = useState(false);
  const [reData, setReData] = useState(null);
  const [tabIndex, setTabIndex] = useState("1");
  const [oneTimeStatus, setOneTimeStatus] = useState([]);
  const [recurringStatus, setRecurringStatus] = useState([]);
  const [exchangeExportData, setexchangeExportData] = useState({singleExchange: [], recurringExchange: []});

  let otOptions = undefined,
    reOptions = undefined;

  useEffect(() => {}, [filterUsed, fData]);

  useEffect(() => {
    fData && exportDataUpdate({ [tabIndex === "1" ? 'singleExchange': 'recurringExchange']: fData})
  }, [fData]);

  function changeHandler(tabIndexs) {
    setTabIndex(tabIndexs);
    analyticsTracking("tab", tabIndexs);
    props.setTab(tabIndexs);
    setFilterUsed(false);
    // setFData("");
  }

  function exportDataUpdate(data) {
    setexchangeExportData({ ...exchangeExportData, ...data})
  }

  const exportExchageActivityDetails = tabIndex => {
    analyticsTracking("export", tabIndex);

    const tabNameMapper = {
      "1": { fileName: "Exchange Activity", tabIdentfier: "singleExchangeActivity", data: exchangeExportData.singleExchange, url: 'exportExchangeActivity'},
      "2": { fileName: "Recurring exchange activity", tabIdentfier: "recurringExchangeActivity", data: exchangeExportData.recurringExchange, url: 'exportRecurringExchange'},
    }

    const filename = tabNameMapper[tabIndex].fileName;
    const tabIdentifier = tabNameMapper[tabIndex].tabIdentfier;
    const exportData = tabNameMapper[tabIndex].data;
    const urlIdentfier = tabNameMapper[tabIndex].url;
    let url = `/donor-portal/api/exchange/${getPrimaryAccount().userId}/${urlIdentfier}`;
    return exportExcelTableData(url ,exportData, filename);
  }

  function handlePop(id) {
    setPopup(!popup);
    setSelectedschedule(id);
  }
  function handleSinglePop(id) {
    setSinglePopup(!singleExchangePop);
    setSelectedTxn(id);
  }
  function CancelSingle() {
    setSinglePopup(!singleExchangePop);
    analyticsTracking("cancel", tabIndex);
    props.cancelTxnSchedule({
      method: "POST",
      page: "exchangeActivity",
      url: `/donor-portal/api/exchange/${
        getPrimaryAccount().userId
      }/cancelSingleExchange?exchangeId=${txnId}`
    });
  }
  function CancelSchedule() {
    setPopup(!popup);
    analyticsTracking("cancel", tabIndex);
    props.cancelReSchedule({
      method: "POST",
      page: "exchangeActivity",
      url: `/donor-portal/api/exchange/${
        getPrimaryAccount().userId
      }/cancelAllSpawnsForExchangeSchedule?exchangeScheduleId=${scheduleId}`
    });
  }

  const handleOtSearch = (value, isOneTime = false, isRecurring = false) => {
    let cloneOneTimeStatus = [...oneTimeStatus];
    const { frequency, yearly, status } = value;
    if (!frequency && !yearly && !status) {
      setFilterUsed(false);
      setFData(otData);
    }
    setFilterUsed(true);
    let filteredData = [...otData];
    //Status
    if (status.length > 0) {
      let filtered = [];
      status.forEach(item => {
        filtered = [
          ...filtered,
          ...filteredData.filter(x => x.status.extDescription == item)
        ];
      });
      filteredData = [...filtered];
    }

    //DateFilter
    if (yearly) {
      let filtered = [];
      if (yearly.length > 0) {
        yearly.forEach(item => {
          filtered = [
            ...filtered,
            ...filteredData.filter(x => {
              let yearNow = moment(x.exchangeStartDate).year();
              return yearNow == parseInt(item);
            })
          ];
          filteredData = [...filtered];
        });
      }
    }

    if (isOneTime) {
      cloneOneTimeStatus = [];
      filteredData.forEach((data, i) => {
        if (!cloneOneTimeStatus.includes(data.status.extDescription)) {
          cloneOneTimeStatus.push(data.status.extDescription);
        }
      });
    } else {
      if (props.tab == 1) {
        if (yearly.length === 0) {
          cloneOneTimeStatus = [];
        } else {
          cloneOneTimeStatus = [];
          filteredData.forEach((data, i) => {
            if (!cloneOneTimeStatus.includes(data.status.extDescription)) {
              cloneOneTimeStatus.push(data.status.extDescription);
            }
          });
        }
      }
    }
    setOneTimeStatus(cloneOneTimeStatus);
    setFData(filteredData);
    setFilterUsed(true);
  };

  const handleReSearch = (value, isOneTime = false, isRecurring = false) => {
    let cloneRecurringStatus = [...recurringStatus];
    setFilterUsed(true);
    const { frequency, yearly, status } = value;
    if (!frequency && !yearly && !status) {
      setFilterUsed(false);
      setFData(false);
    }
    let filteredData = [...reData];
    if (frequency) {
      let ogData = filteredData;
      let filtered = "";
      let temp = [];
      if (frequency.length == 1) {
        const filteredSearch = ogData.filter(x => {
          if (frequency == "Custom") {
            return (
              x.frequency[0] !== "Anually" ||
              x.frequency[0] !== "Quarterly" ||
              x.frequency[0] !== "Monthly"
            );
          } else {
            return x.frequency == frequency;
          }
        });
        filteredData = filteredSearch;
      }
      if (frequency.length > 1) {
        frequency.forEach(item => {
          filtered = ogData.filter(x => {
            if (frequency == "Custom") {
              return (
                x.frequency[0] !== "Anually" ||
                x.frequency[0] !== "Quarterly" ||
                x.frequency[0] !== "Monthly"
              );
            } else {
              return x.frequency == item;
            }
          });
          filtered.forEach(x => temp.push(x));
          filtered = [...temp.flat()];
          filteredData = filtered;
        });
      }
    }

    //Status
    if (status) {
      let filtered;
      let temp = [];
      let filteredStatus = "";
      let ogData = filteredData;
      if (status.length == 1) {
        filteredStatus = ogData.filter(x => x.status == status);
        filteredData = filteredStatus;
      }
      if (status.length > 1) {
        status.forEach(item => {
          filtered = ogData.filter(x => x.status == item);
          filtered.forEach(x => temp.push(x));
          filteredStatus = [...temp.flat()];
          filteredData = filteredStatus;
        });
      }
    }

    //DateFilter
    if (yearly) {
      let filtered;
      let temp = [];
      let filteredDates = "";
      let ogData = filteredData;
      if (yearly.length === 1) {
        let filteredDates = ogData.filter(x => {
          let yearNow = moment(x.exchangeCreateDate).year();
          return yearNow == parseInt(yearly);
        });
        filteredData = filteredDates;
      }
      if (yearly.length > 1) {
        yearly.forEach(item => {
          filtered = ogData.filter(x => {
            let yearNow = moment(x.exchangeCreateDate).year();
            return yearNow == parseInt(item);
          });

          filtered.forEach(x => temp.push(x));
          filteredDates = [...temp.flat()];
          filteredData = filteredDates;
        });
      }
    }
    if (isRecurring) {
      cloneRecurringStatus = [];
      filteredData.forEach((data, i) => {
        if (!cloneRecurringStatus.includes(data.status)) {
          cloneRecurringStatus.push(data.status);
        }
      });
    } else {
      cloneRecurringStatus = [];
      if (props.tab == 1) {
        if (yearly.length === 0 && frequency.length === 0) {
          cloneRecurringStatus = [];
        } else {
          cloneRecurringStatus = [];
          filteredData.forEach((data, i) => {
            if (!cloneRecurringStatus.includes(data.status)) {
              cloneRecurringStatus.push(data.status);
            }
          });
        }
      }
    }
    setRecurringStatus(cloneRecurringStatus);
    setFData(filteredData);
    setFilterUsed(true);
  };

  const changeMobTab = activeKey => {
    setFilterUsed(false);
    props.setTab(activeKey);
    setActive(activeKey);
    analyticsTracking("tab", activeKey);
  };

  const tabPaneFuncton = (oneTime, recurring) => {
    let count = props.cancel;
    count++;
    let oTStatus = [],
      reStatus = [],
      reFrequency = [],
      otYearly = [],
      reYearly = [];
    let recurringFilters = {},
      oneTimeFilters = {};
    if (oneTime) {
      oneTime &&
        oneTime.exchangeList.map((each, index) => {
          if (oTStatus.indexOf(each.status.extDescription) < 0) {
            oTStatus.push(each.status.extDescription);
          }
        });
      oneTime &&
        oneTime.exchangeList.map((each, index) => {
          if (otYearly.indexOf(moment(each.exchangeStartDate).year()) < 0) {
            otYearly.push(moment(each.exchangeStartDate).year());
          }
        });
      oneTimeFilters.statusGrantFilters = oTStatus;
      oneTimeFilters.yearlyGrantFilters = otYearly;
      otOptions = oneTimeFilters;
    }
    if (recurring) {
      recurring &&
        recurring.exchanges.map((each, index) => {
          if (reStatus.indexOf(each.status) < 0) {
            reStatus.push(each.status);
          }
        });
      recurring &&
        recurring.exchanges.map((each, index) => {
          if (reFrequency.indexOf(each.frequency) < 0) {
            reFrequency.push(each.frequency);
          }
        });
      recurring &&
        recurring.exchanges.map((each, index) => {
          if (reYearly.indexOf(moment(each.exchangeStartDate).year()) < 0) {
            reYearly.push(moment(each.exchangeStartDate).year());
          }
        });
      recurringFilters.recurringGrantFilters = reStatus;
      recurringFilters.frequencyGrantFilters = reFrequency;
      recurringFilters.yearlyGrantFilters = reYearly;
      reOptions = recurringFilters;
    }

    const exchanges = {
      title: "Exchanges",
      key: 1,
      destComponent: "table",
      data: oneTime.exchangeList,
      text: "You currently have no exchanges",
      options: oneTimeFilters,

      columnConfig: [
        {
          title: () => (
            <AlignCenter className="tableInfoAlignment">
              Action{" "}
              <Tooltip
                placement="right"
                title={<p>Click to see more actions for transactions</p>}
              >
                <span className="infotooltip">
                  <img alt="infoIcon" src={infoIcon} />
                </span>
              </Tooltip>
            </AlignCenter>
          ),
          render: (value, row) => {
            let isLCP = row.exchangetype.includes('Low Carbon Global Equity');
            return (
              <ActionTitle noClick={isLCP}>
                <Tooltip
                  overlayClassName="exchangeTooltip"
                  placement="bottom"
                  title={renderValues(
                    value,
                    row,
                    props,
                    tabIndex,
                    handleSinglePop
                  )}
                >
                  <img alt="tableIcon" src={isLCP ? tableIconGrey : tableIcon} />
                </Tooltip>
              </ActionTitle>
            );
          },
          width: 80
        },
        {
          title: () => <div>Entered Date</div>,
          dataIndex: "exchangeStartDate",
          key: "exchangeStartDate",
          render: value => {
            let dateval = moment(moment.tz(value, "America/New_York")).format(
              "L"
            );

            return (
              <TableLabel>
                {dateval === "Invalid date" ? <div>&mdash;</div> : dateval}{" "}
              </TableLabel>
            );
          },
          width: 150,
          sortDirections: ["ascend", "descend"],
          sorter: (a, b) =>
            compareByAlph(a.exchangeStartDate, b.exchangeStartDate)
        },
        {
          title: () => <div>Exchange Type</div>,
          dataIndex: "exchangetype",
          key: "exchangetype",
          render: value => {
            return <TableLabel>{value} </TableLabel>;
          },
          width: 150,
          sortDirections: ["ascend", "descend"],
          sorter: (a, b) => compareByAlph(a.exchangetype, b.exchangetype)
        },
        {
          title: () => <div>Trade Date</div>,
          dataIndex: "tradeDate",
          key: "tradeDate",
          render: value => {
            let dateNow = moment(moment.tz(value, "America/New_York")).format(
              "L"
            );
            if (dateNow == "Invalid date") {
              return (
                <AlignTableContents alignment>
                  <TableLabel> &mdash;</TableLabel>
                </AlignTableContents>
              );
            } else
              return (
                <AlignTableContents alignment>
                  <TableLabel>{dateNow}</TableLabel>
                </AlignTableContents>
              );
          },
          width: 150,
          sortDirections: ["ascend", "descend"],
          sorter: (a, b) => compareByAlph(a.tradeDate, b.tradeDate)
        },
        {
          title: () => <div>Allocation Type</div>,
          dataIndex: "allocationType",
          key: "allocationType",
          render: value => {
            return (
              <AlignTableContents>
                <TableLabel>
                  {value ? (
                    <>
                      {value == "SHARE" ? (
                        <span>{"Units"}</span>
                      ) : (
                        <span>{value.toLowerCase()}</span>
                      )}
                    </>
                  ) : (
                    <div>&mdash;</div>
                  )}
                </TableLabel>
              </AlignTableContents>
            );
          },
          width: 150,
          sortDirections: ["ascend", "descend"],
          sorter: (a, b) => compareByAlph(a.allocationType, b.allocationType)
        },
        {
          title: () => <div>Status</div>,
          dataIndex: "status",
          key: "status",
          render: value => {
            return (
              <AlignTableContents>
                <TableLabel>
                  {value ? value.extDescription : <div>&mdash;</div>}{" "}
                </TableLabel>
              </AlignTableContents>
            );
          },
          width: 150,
          sortDirections: ["ascend", "descend"],
          sorter: (a, b) =>
            compareByAlph(a.status.extDescription, b.status.extDescription)
        },
        {
          dataIndex: "isRecurring",
          key: "isRecurring",
          render: value => {
            return (
              <>
                {value ? (
                  <Tooltip
                    placement="bottomRight"
                    title={
                      "Indicates that this is part of a recurring exchange schedule."
                    }
                  >
                    <img alt="recurringIcon" src={recurringIcon} />
                  </Tooltip>
                ) : null}
              </>
            );
          },
          width: 50
        }
      ]
    };

    const recurringFunds = {
      title: "Recurring exchange schedule",
      key: 2,
      destComponent: "table",
      data: recurring.exchanges,
      text: "You currently have no exchanges",
      options: recurringFilters,
      columnConfig: [
        {
          title: () => (
            <div className="tableInfoAlignment">
              Action{" "}
              <Tooltip
                placement="right"
                title={<p>Click to see more actions for transactions</p>}
              >
                <span className="infotooltip">
                  <img alt="infoIcon" src={infoIcon} />
                </span>
              </Tooltip>
            </div>
          ),
          render: (value, row) => {
            const { access } = props.user.role;
            let toolTipWidth =
              row.status === "Active" && (access === "All Access" || isReadOnlyWithExchangeRole);
            let isLCP = row.exchangetype && row.exchangetype.includes('Low Carbon Global Equity');
            return (
              <ActionTitle noClick={isLCP}>
                <Tooltip
                  overlayClassName={`${
                    toolTipWidth
                      ? "exchangeTooltip cancelTransaction"
                      : "exchangeTooltip"
                  }`}
                  placement="bottom"
                  title={renderRecurringValues(
                    value,
                    row,
                    props,
                    tabIndex,
                    handlePop
                  )}
                >
                  <img alt="tableIcon" src={isLCP ? tableIconGrey : tableIcon} />
                </Tooltip>
              </ActionTitle>
            );
          },
          width: 80
        },
        {
          title: () => <div>Entered Date</div>,
          dataIndex: "exchangeCreateDate",
          key: "exchangeCreateDate",
          render: value => {
            let dateNow = moment(moment.tz(value, "America/New_York")).format(
              "L"
            );
            if (dateNow == "Invalid date") {
              return <TableLabel> &mdash;</TableLabel>;
            } else return <TableLabel>{dateNow}</TableLabel>;
          },
          width: 150,
          sortDirections: ["ascend", "descend"],
          sorter: (a, b) =>
            compareByAlph(a.exchangeCreateDate, b.exchangeCreateDate)
        },
        {
          title: () => <div>Allocation Type</div>,
          dataIndex: "allocationType",
          key: "allocationType",
          render: value => {
            return (
              <TableLabel>
                {value ? (
                  <>
                    {value == "SHARE" ? (
                      <span>{"Units"}</span>
                    ) : (
                      <span>{value.toLowerCase()}</span>
                    )}
                  </>
                ) : (
                  <div>&mdash;</div>
                )}
              </TableLabel>
            );
          },
          width: 150,

          sortDirections: ["ascend", "descend"],
          sorter: (a, b) => compareByAlph(a.allocationType, b.allocationType)
        },
        {
          title: () => <div>Frequency</div>,
          dataIndex: "frequency",
          key: "frequency",
          render: value => {
            return (
              <AlignTableContents alignment>
                <TableLabel>{value} </TableLabel>
              </AlignTableContents>
            );
          },
          width: 150,
          sortDirections: ["ascend", "descend"],
          sorter: (a, b) => compareByAlph(a.frequency, b.frequency)
        },
        {
          title: () => (
            <div>
              Next Scheduled <br /> Date
            </div>
          ),
          dataIndex: "nextScheduledExchangeDate",
          key: "nextScheduledExchangeDate",
          render: value => {
            let dateNow = moment(moment.tz(value, "America/New_York")).format(
              "L"
            );
            if (dateNow == "Invalid date") {
              return (
                <AlignTableContents>
                  <TableLabel> &mdash;</TableLabel>
                </AlignTableContents>
              );
            } else
              return (
                <AlignTableContents>
                  <TableLabel>{dateNow}</TableLabel>
                </AlignTableContents>
              );
          },
          width: 150,
          sortDirections: ["ascend", "descend"],
          sorter: (a, b) =>
            compareByAlph(
              a.nextScheduledExchangeDate,
              b.nextScheduledExchangeDate
            )
        },
        {
          title: () => (
            <div>
              Number of
              <br />
              Remaining <br />
              Exchanges
            </div>
          ),
          dataIndex: "noOfExchangesRemaining",
          key: "noOfExchangesRemaining",
          render: value => {
            return (
              <AlignTableContents>
                <TableLabel>
                  {value != 0 ? value < 10 ? "0" + value : value : <div>0</div>}{" "}
                </TableLabel>
              </AlignTableContents>
            );
          },
          width: 100,
          sortDirections: ["ascend", "descend"],
          sorter: (a, b) =>
            compareByAlph(a.noOfExchangesRemaining, b.noOfExchangesRemaining)
        },
        {
          title: () => <div>Status</div>,
          dataIndex: "status",
          key: "status",
          render: value => {
            return (
              <AlignTableContents>
                <TableLabel>{value} </TableLabel>
              </AlignTableContents>
            );
          },
          width: 100,
          sortDirections: ["ascend", "descend"],
          sorter: (a, b) => compareByAlph(a.status, b.status)
        }
      ]
    };

    if (
      props.singleExchanges.exchangeList.length > 0 &&
      recurring &&
      recurring.exchanges.length < 1
    ) {
      return [exchanges];
    } else if (
      props.singleExchanges.exchangeList.length > 0 &&
      recurring &&
      recurring.exchanges.length > 0
    ) {
      return [exchanges, recurringFunds];
    } else {
      return [exchanges, recurringFunds];
    }
  };

  if (props.singleExchanges && !otData) {
    setOtData(props.singleExchanges.exchangeList);
  }
  if (props.recurringExchanges && !reData) {
    setReData(props.recurringExchanges.exchanges);
  }

  return (
    <div className="exchanges">
      <AlertMessagePrimary
        title="Cancel Exchange"
        visible={popup}
        onOk={() => CancelSchedule()}
        onCancel={() => handlePop()}
        width={480}
        cancelText="No, take me back"
        okText="CONTINUE"
      >
        Are you sure you want to cancel this exchange schedule? Canceling will
        delete all information entered for all upcoming spawns of this exchange.
        <br />
        <span>Do you want to continue?</span>
      </AlertMessagePrimary>
      <AlertMessagePrimary
       data-test="cancel-exchange"
        title="Cancel Exchange"
        title="Cancel Exchange"
        visible={singleExchangePop}
        onOk={() => CancelSingle()}
        onCancel={() => handleSinglePop()}
        width={480}
        cancelText="No, take me back"
        okText="CONTINUE"
      >
        Are you sure you want to cancel this exchange? Selecting continue will
        cancel the Exchange.
        <br />
        <span>Do you want to continue?</span>
      </AlertMessagePrimary>
      {props.singleExchanges && props.recurringExchanges && (
        <Row>
          <IconsPlaceNew>

            <StyleLessButtons
              onClick={() => exportExchageActivityDetails(tabIndex)}
              id="btnExport"
            >
              <IconPadding primary={true}>
                <img alt="ExportIcon" src={exportIcon} />
                <DataExportPrint>EXPORT</DataExportPrint>
              </IconPadding>
            </StyleLessButtons>

            <PrintComponents
              className="i_print"
              trigger={
                <StyleLessButtons
                  className="mobile-view-accountDetails"
                  id={"btnPrint" + tabIndex}
                >
                  <IconPadding
                    className="ml2"
                    onClick={() => analyticsTracking("print", tabIndex)}
                  >
                    <img alt="printIcon" src={printIcon} />
                    <DataExportPrint>PRINT</DataExportPrint>
                  </IconPadding>
                </StyleLessButtons>
              }
            >
              {tabIndex == "1" ? (
                <>
                  <ExchangeSelectPrint
                    selectedTabs={"1"}
                    data={props.singleExchanges.exchangeList}
                    hasIcons={true}
                  />
                </>
              ) : (
                <>
                  <ExchangeSelectPrint
                    selectedTabs={"2"}
                    data={props.recurringExchanges.exchanges}
                  />
                </>
              )}
            </PrintComponents>
          </IconsPlaceNew>

          <Col lg={24} md={0} sm={0} xs={0}>
            <TabsComponent
              tabPanes={tabPaneFuncton(
                props.singleExchanges,
                props.recurringExchanges
              )}
              tabConfig={tabConfig}
              exportDataUpdate={exportDataUpdate}
              containerHeight="initial"
              yscroll={true}
              xscroll={true}
              yscrollC={false}
              data-test="tab-test"
              enableScroll={true}
              getChange={changeHandler}
              className="tbExchangeSelect"
            />
          </Col>
          <Col lg={0} md={24} sm={24} xs={24}>
            <TabsPaneEA defaultActiveKey="1" onChange={changeMobTab}>
              <TabPane tab="Exchanges" key="1">
                <AdvancedSearch
                  handleSearch={handleOtSearch}
                  menu={otOptions}
                  data-test="AdvanceSearch"
                  oneTimeStatus={oneTimeStatus}
                  recurringStatus={recurringStatus}
                />
                {props.tab == 1 && filterUsed ? (
                  <div>
                    {fData &&
                      fData.map((data, index) => (
                        <RenderCard
                          id={"ExchangeCard1" + index}
                          index={index}
                          data={data}
                          component="ExchangesCard"
                        />
                      ))}
                  </div>
                ) : (
                  <div>
                    {props.singleExchanges &&
                    props.singleExchanges.exchangeList.length <= 0 ? (
                      <div className="noDataPlacement">
                        <div>You currently have no exchanges</div>
                      </div>
                    ) : null}

                    {props.singleExchanges &&
                      props.singleExchanges.exchangeList.map((data, index) => (
                        <RenderCard
                          id={"ExchangesCard2" + index}
                          index={index}
                          data={data}
                          component="ExchangesCard"
                        />
                      ))}
                  </div>
                )}
              </TabPane>

              {props.recurringExchanges &&
                props.recurringExchanges.exchanges.length > 0 && (
                  <TabPane
                    tab="Recurring Exchange Schedules"
                    key="2"
                    onChange={changeMobTab}
                    id="tbRecurringExchangeSchedules"
                  >
                    <AdvancedSearch
                      handleSearch={handleReSearch}
                      menu={reOptions}
                      data-test="AdvanceSearch2"
                      oneTimeStatus={oneTimeStatus}
                      recurringStatus={recurringStatus}
                    />
                    {props.tab == 2 && filterUsed ? (
                      <div>
                        {fData &&
                          fData.map((data, index) => (
                            <RenderCard
                              index={index}
                              data={data}
                              component="RecurringExchangesCard"
                            />
                          ))}
                      </div>
                    ) : (
                      <div>
                        {props.recurringExchanges &&
                          props.recurringExchanges.exchanges.map(
                            (data, index) => (
                              <RenderCard
                                index={index}
                                data={data}
                                component="RecurringExchangesCard"
                              />
                            )
                          )}
                      </div>
                    )}
                  </TabPane>
                )}
            </TabsPaneEA>
            <ContentDivider />
          </Col>
        </Row>
      )}
    </div>
  );
}
ExchangeSelect.propTypes = {
  tab: PropTypes.number,
  currentTab: PropTypes.string,
  recurringExchanges: PropTypes.object,
  singleExchanges: PropTypes.object,
  cancelSingle: PropTypes.number
};

const mapStateToProps = state => ({
  currentTab: state.getIn(["exchangeActivity", "currentTab", "data"]),
  tab: state.getIn(["exchangeActivity", "tab"]),
  csrBusinessFunction: state.getIn(["globalState", "csr", "business_functions"])
});

export const mapDispatchToProps = dispatch => ({
  setType: data => dispatch(setExchangeType(data)),
  setTab: data => dispatch(setTab(data)),
  cancelTxnSchedule: data => dispatch(cancelTxnSchedule(data)),
  cancelReSchedule: data => dispatch(cancelTxnSchedule(data))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ExchangeSelect)
);
